import { render } from "./font_modal.vue?vue&type=template&id=530362a0"
import script from "./font_modal.vue?vue&type=script&lang=js"
export * from "./font_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/font_modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "530362a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('530362a0', __exports__)) {
    api.reload('530362a0', __exports__)
  }
  
  module.hot.accept("./font_modal.vue?vue&type=template&id=530362a0", () => {
    api.rerender('530362a0', render)
  })

}


export default __exports__